import md5 from 'js-md5'
import CryptoJS from 'crypto-js/crypto-js'

Array.prototype.indexOf = function(val) { 
    for (var i = 0; i < this.length; i++) { 
        if (this[i] == val) return i; 
    } 
    return -1; 
};
Array.prototype.remove = function(val) { 
    var index = this.indexOf(val); 
    if (index > -1) { 
        this.splice(index, 1); 
    } 
};
//日期扩展format
Date.prototype.format = function(fmt) { 
    var o = { 
       "M+" : this.getMonth()+1,                 //月份 
       "d+" : this.getDate(),                    //日 
       "h+" : this.getHours(),                   //小时 
       "m+" : this.getMinutes(),                 //分 
       "s+" : this.getSeconds(),                 //秒 
       "q+" : Math.floor((this.getMonth()+3)/3), //季度 
       "S"  : this.getMilliseconds()             //毫秒 
   }; 
   if(/(y+)/.test(fmt)) {
           fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
   }
    for(var k in o) {
       if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
   return fmt; 
}      

// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse("6215086662150866");
const IV = CryptoJS.enc.Utf8.parse('6215086662150866');

const commonFn={
    pwd99:function(data){
        if(!data) return null
        let password = data
        for (let i = 0; i < 99; i++) {
            password = md5(password); 
        }
        return password
    },
    //存储
    setStorage:function(key,data){
        if(!key) return;
        if(typeof data=='object'){
            data=JSON.stringify(data);
        }
        window.sessionStorage.setItem(key,data)
    },
    //获取存储的对象值
    getStorage:function(key){
        if(!key) return;
        let data=window.sessionStorage.getItem(key);
        return JSON.parse(data);
    },
    //获取存储的字符串的值
    getStorageS:function(key){
        return window.sessionStorage.getItem(key);
    },
    //移出全部存储
    removeStorage:function(){
        window.sessionStorage.clear();
    },
    //获取日期
    getAllDate() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year +''+ month +''+ day;
    },
    //获取当前时间
    getAllTime(){
        var date = new Date();//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '';
        var D = (date.getDate()<10 ? '0'+date.getDate():date.getDate())+ '';
        var h = (date.getHours()<10 ? '0'+date.getHours():date.getHours())+ '';
        var m = (date.getMinutes()<10 ? '0'+date.getMinutes():date.getMinutes())+ '';
        var s = (date.getSeconds()<10 ? '0'+date.getSeconds():date.getSeconds());
        return Y+M+D+h+m+s; 
    },
    getUUID(){
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "";
     
        var uuid = s.join("");
        return uuid;
    },
    //获得时间戳
    getTime() {
        var date = new Date();
        return date.getTime()
    },
    //数组移出元素
    removeArr(val,arr){
        arr.remove(val)
    },
    //数组移出对象元素（多个文件的数组，删除某个文件）
    arrRmObj(val,arr){
        for(var i=0;i<arr.length;i++){
            if(arr[i].attachUrl==val.attachUrl){
                arr.splice(i,1);
            }
        }
    },
    indexOf(val,arr){
        return arr.indexOf(val);
    },
    //获得验证码图片
    getCode(window, document){
        var size = 4;//设置验证码长度
        function GVerify(options) { //创建一个图形验证码对象，接收options对象为参数
            this.options = { //默认options参数值
                id: "", //容器Id
                canvasId: "verifyCanvas", //canvas的ID
                width: "13", //默认canvas宽度
                height: "4", //默认canvas高度
                type: "blend", //图形验证码默认类型blend:数字字母混合类型、number:纯数字、letter:纯字母
                code: "",
            }
            if(Object.prototype.toString.call(options) == "[object Object]"){//判断传入参数类型
                for(var i in options) { //根据传入的参数，修改默认参数值
                    this.options[i] = options[i];
                }
            }else{
                this.options.id = options;
            }
            
            this.options.numArr = "1,2,3,4,5,6,7,8,9".split(",");
            this.options.letterArr = getAllLetter();

            this._init();
            this.refresh();
        }

        GVerify.prototype = {
            /**版本号**/
            version: '1.0.0',
            
            /**初始化方法**/
            _init: function() {
                var con = document.getElementById(this.options.id);
                var canvas = document.createElement("canvas");
                this.options.width = con.offsetWidth > 0 ? con.offsetWidth : "200";
                this.options.height = con.offsetHeight > 0 ? con.offsetHeight : "50";
                canvas.id = this.options.canvasId;
                canvas.width = this.options.width;
                canvas.height = this.options.height;
                canvas.style.cursor = "pointer";
                canvas.innerHTML = "您的浏览器版本不支持canvas";
                con.appendChild(canvas);
                var parent = this;
                canvas.onclick = function(){
                    parent.refresh();
                }
            },
            
            /**生成验证码**/
            refresh: function() {
                this.options.code = "";
                var canvas = document.getElementById(this.options.canvasId);
                if(canvas.getContext) {
                    var ctx = canvas.getContext('2d');
                }else{
                    return;
                }
                
                ctx.textBaseline = "middle";

                ctx.fillStyle = randomColor(180, 240);
                ctx.fillRect(0, 0, this.options.width, this.options.height);

                if(this.options.type == "blend") { //判断验证码类型
                    var txtArr = this.options.numArr.concat(this.options.letterArr);
                } else if(this.options.type == "number") {
                    var txtArr = this.options.numArr;
                } else {
                    var txtArr = this.options.letterArr;
                }

                for(var i = 1; i <=size; i++) {
                    var txt = txtArr[randomNum(0, txtArr.length)];
                    this.options.code += txt;
                    ctx.font = randomNum(this.options.height/2, this.options.height) + 'px SimHei'; //随机生成字体大小
                    ctx.fillStyle = randomColor(50, 160); //随机生成字体颜色        
                    ctx.shadowOffsetX = randomNum(-3, 3);
                    ctx.shadowOffsetY = randomNum(-3, 3);
                    ctx.shadowBlur = randomNum(-3, 3);
                    ctx.shadowColor = "rgba(0, 0, 0, 0.3)";
                    var x = this.options.width / (size+1) * i;
                    var y = this.options.height / 2;
                    var deg = randomNum(-30, 30);
                    /**设置旋转角度和坐标原点**/
                    ctx.translate(x, y);
                    ctx.rotate(deg * Math.PI / 180);
                    ctx.fillText(txt, 0, 0);
                    /**恢复旋转角度和坐标原点**/
                    ctx.rotate(-deg * Math.PI / 180);
                    ctx.translate(-x, -y);
                }
                /**绘制干扰线**/
                for(var i = 0; i < 4; i++) {
                    ctx.strokeStyle = randomColor(40, 180);
                    ctx.beginPath();
                    ctx.moveTo(randomNum(0, this.options.width), randomNum(0, this.options.height));
                    ctx.lineTo(randomNum(0, this.options.width), randomNum(0, this.options.height));
                    ctx.stroke();
                }
                /**绘制干扰点**/
                for(var i = 0; i < this.options.width/4; i++) {
                    ctx.fillStyle = randomColor(0, 255);
                    ctx.beginPath();
                    ctx.arc(randomNum(0, this.options.width), randomNum(0, this.options.height), 1, 0, 2 * Math.PI);
                    ctx.fill();
                }
            },
            
            /**验证验证码**/
            validate: function(code){
                var code = code.toLowerCase();
                var v_code = this.options.code.toLowerCase();
                if(code == v_code){
                    return true;
                }else{
                    this.refresh();
                    return false;
                }
            }
        }
        /**生成字母数组**/
        function getAllLetter() {
            var letterStr = "a,b,c,d,e,f,g,h,i,j,k,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,U,V,W,X,Y,Z";
            return letterStr.split(",");
        }
        /**生成一个随机数**/
        function randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        }
        /**生成一个随机色**/
        function randomColor(min, max) {
            var r = randomNum(min, max);
            var g = randomNum(min, max);
            var b = randomNum(min, max);
            return "rgb(" + r + "," + g + "," + b + ")";
        }
        window.GVerify = GVerify;
    },
    //日期格式化(原始数据，格式样式[yyyy-MM-dd])
    format(data,rule){
        return new Date(data).format(rule);
    },
    getConsole(page,message){
        console.log(page+'——————————————');
        console.log(message)
    },
    //aes加密
    Encrypt(word, keyStr, ivStr) {
        let key = KEY
        let iv = IV
      
        if (keyStr) {
          key = CryptoJS.enc.Utf8.parse(keyStr);
          iv = CryptoJS.enc.Utf8.parse(ivStr);
        }
      
        let srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        });
       // console.log("-=-=-=-", encrypted.ciphertext)
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
      
    },
    //aes解密
    Decrypt(word, keyStr, ivStr) {
        let key  = KEY
        let iv = IV
      
        if (keyStr) {
          key = CryptoJS.enc.Utf8.parse(keyStr);
          iv = CryptoJS.enc.Utf8.parse(ivStr);
        }
      
        let base64 = CryptoJS.enc.Base64.parse(word);
        let src = CryptoJS.enc.Base64.stringify(base64);
      
        var decrypt = CryptoJS.AES.decrypt(src, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        });
      
        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }
}

export default commonFn
//收费金额验证
export const isMoney=function(data){
    var reg = /^\+?(\d|[1-9]\d{1,2})(\.[0-9]{1,2})?$/;
    return reg.test(data)
}
//充值金额限制
export const isSetMoney=function(data){
    var reg = /^\+?((\d|[1-4]\d{1,3}|[5-9]\d{1,2})(\.[0-9]{1,2})?|5000)?$/;
    return reg.test(data)
}
// 手机号验证
export const isvalidPhone=function(str) {
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    return reg.test(str)
}
//姓名验证
export const isvalidName=function(str) {
    const reg = /^[\u4e00-\u9fa5a-zA-Z]+$/
    return reg.test(str)
}
//年龄验证
export const isvalidAge=function(str){
    const reg=/^(?:[1-9][0-9]?|1[01234][0-9]|150)$/;
    return reg.test(str);
}


// WEBPACK FOOTER //
// ./src/service/common.js